<template>
  <div class="forbidden-div">
    <span class="forbidden-span">Use Cognizant user to access the app.</span>
    <button class="logout-button" @click="logout">Sign Out</button>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService';

export default {
  name: 'ForbiddenContainer',
  methods: {
    logout() {
      AuthenticationService.logout();
    },
  },
};
</script>

<style scoped>
  .forbidden-div {
    display: grid;
    place-items: center;
    padding: 10px;
    background-color: #FF5252;
    gap: 12px;
  }

  .forbidden-span {
    color: white;
    font-weight: bold;
    font-size: large;
  }

  .logout-button {
    color: #FF5252;
    background-color: white;
    border: none;
    padding: 8px 16px;
    font-weight: bold;
    cursor: pointer;
    border-radius: 4px;
  }
</style>
